import { render, staticRenderFns } from "./addInvoiceQu.vue?vue&type=template&id=fdd65d90"
import script from "./addInvoiceQu.vue?vue&type=script&lang=js"
export * from "./addInvoiceQu.vue?vue&type=script&lang=js"
import style0 from "./addInvoiceQu.vue?vue&type=style&index=0&id=fdd65d90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports